function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineComponent, h } from '@vue/composition-api';
import CloseV1Outlined from '@kibt/meta-ui-icons/es/icons/CloseV1Outlined';
import Button from '../button';
import { withInstall } from '../util';
import Config from '../config';
import "../style/components/dialog.css";
import { useLockScroll } from '../util/useLockScroll';
var dialogProps = {
  visible: {
    type: Boolean,
    "default": false
  },
  title: {
    type: String,
    "default": null
  },
  place: {
    type: String,
    "default": 'center'
  },
  content: {
    type: [String, Object],
    "default": null
  },
  // 是否展示关闭icon
  showClose: {
    type: Boolean,
    "default": false
  },
  dialogClass: {
    type: String,
    "default": ''
  },
  mask: {
    type: Boolean,
    "default": true
  },
  maskClosable: {
    type: Boolean,
    "default": true
  },
  maskClass: {
    type: String,
    "default": ''
  },
  showOk: {
    type: Boolean,
    "default": true
  },
  lockScroll: {
    type: Boolean,
    "default": true
  },
  okText: {
    type: String,
    "default": null
  },
  okButtonProps: {
    type: Object,
    "default": function _default() {
      return {
        type: 'primary',
        block: true
      };
    }
  },
  showCancel: {
    type: Boolean,
    "default": true
  },
  cancelText: {
    type: String,
    "default": null
  },
  cancelButtonProps: {
    type: Object,
    "default": function _default() {
      return {
        type: 'default',
        block: true
      };
    }
  },
  buttonDirection: {
    type: String,
    "default": 'horizontal'
  }
};
var Dialog = defineComponent({
  name: 'm-dialog',
  props: dialogProps,
  emits: ['ok', 'cancel', 'close'],
  setup: function setup(props, context) {
    useLockScroll(function () {
      return props.lockScroll && props.visible;
    });
    return function () {
      var locales = Config.getLocale();
      var title;

      if (props.title) {
        title = h("div", {
          "class": "m-dialog__title"
        }, [props.title]);
      } else if (context.slots.title) {
        title = context.slots.title();
      }

      var content;

      if (props.content) {
        content = h("div", {
          "class": "m-dialog__content ".concat(title ? '' : 'content_only')
        }, [props.content]);
      } else if (context.slots.content) {
        content = context.slots.content();
      }

      return h("div", [h("transition", {
        "attrs": {
          "name": "m-ani-fade",
          "appear": true
        }
      }, [props.visible && props.mask && h("div", {
        "class": "m-mask ".concat(props.maskClass),
        "on": {
          "click": function click() {
            return props.maskClosable && context.emit('close');
          }
        }
      })]), h("transition", {
        "attrs": {
          "name": "m-ani-fade",
          "appear": true
        }
      }, [props.visible && h("div", {
        "class": "m-dialog ".concat(props.dialogClass, " ").concat(props.showClose ? 'closable' : '', " m-dialog_").concat(props.place)
      }, [props.showClose && h("div", {
        "class": "m-dialog__close"
      }, [h(CloseV1Outlined, {
        "on": {
          "click": function click() {
            return context.emit('close');
          }
        }
      })]), title, content, (props.showOk || props.showCancel) && h("div", {
        "class": "m-dialog__btns ".concat(props.buttonDirection)
      }, [props.showCancel && h(Button, {
        "props": _objectSpread({}, props.cancelButtonProps),
        "on": {
          "click": function click() {
            return context.emit('cancel');
          }
        }
      }, [props.cancelText || locales.Dialog.cancelText]), props.showOk && props.showCancel && props.buttonDirection === 'horizontal' && h("div", {
        "class": "padding"
      }), props.showOk && h(Button, {
        "props": _objectSpread({}, props.okButtonProps),
        "on": {
          "click": function click() {
            return context.emit('ok');
          }
        }
      }, [props.okText || locales.Dialog.okText])])])])]);
    };
  }
});
withInstall(Dialog);
export default Dialog;